export default "__VITE_ASSET__7DnzzN3V__"